import { render, staticRenderFns } from "./FormIntegrations.vue?vue&type=template&id=5763b0aa&scoped=true&"
import script from "./FormIntegrations.vue?vue&type=script&lang=js&"
export * from "./FormIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./FormIntegrations.vue?vue&type=style&index=0&id=5763b0aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5763b0aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
